import { SVGProps, Ref, forwardRef } from 'react';

export const FacebookBrandSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M13.333 22.92C18.78 22.262 23 17.624 23 12c0-6.075-4.925-11-11-11S1 5.925 1 12c0 5.159 3.551 9.488 8.342 10.677v-7.315h-2.27V12h2.27v-1.452c0-3.744 1.694-5.478 5.368-5.478.696 0 1.897.136 2.39.273v3.049c-.26-.026-.713-.04-1.272-.04-1.804 0-2.5.682-2.5 2.46V12h3.596l-.616 3.361h-2.975z"
                fill="#0866FF"
            />
            <path
                d="M9.342 22.677v-7.315h-2.27V12h2.27v-1.452c0-3.744 1.694-5.478 5.368-5.478.696 0 1.897.136 2.39.273v3.049c-.26-.026-.713-.04-1.272-.04-1.804 0-2.5.682-2.5 2.46V12h3.596l-.616 3.361h-2.975v7.559a11.1 11.1 0 0 1-3.99-.243"
                fill="white"
            />
        </g>
    </svg>
));
FacebookBrandSize24Glyph.displayName = 'FacebookBrandSize24Glyph';
